module.exports = __webpack_public_path__ + "assets/img/kayak.f98b0617.png";